import { AppShell } from "@/components/app/AppShell";
import { AnalyticsView } from "@/components/app/Analytics";

export default function AdminAnalytics() {
  return (
    <AppShell eyebrow="— SUPER ADMIN" title="Platform analytics">
      <AnalyticsView endpoint="/admin/analytics" admin />
    </AppShell>
  );
}
